import classNames from 'classnames';

import Typography, { TypographyProps } from './Typography';

import styles from '../../styles/typography/summary-description.module.css';

function SummaryDescription({ tag = 'div', className = null, ...props }: TypographyProps) {
    return (
        <Typography tag={tag} className={classNames([styles.container, className])} {...props} />
    );
}

export default SummaryDescription;
